var _defs, _ellipse, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ehearzcP6Hm1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ehearzcP6Hm2-fill",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ehearzcP6Hm2-fill-0",
    offset: "0%",
    stopColor: "#f4c023"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ehearzcP6Hm2-fill-1",
    offset: "100%",
    stopColor: "#e14730"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 140,
    ry: 140,
    transform: "translate(150 150.000001)",
    fill: "url(#ehearzcP6Hm2-fill)",
    stroke: "#000",
    strokeWidth: 3,
    strokeMiterlimit: 12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61.060524,
    height: 251.205141,
    rx: 0,
    ry: 0,
    transform: "matrix(.692976 0 0 0.733701 128.843262 57.845269)",
    fill: "#fff",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 61.060524,
    height: 251.205141,
    rx: 0,
    ry: 0,
    transform: "matrix(0 0.692976-.733701 0 242.154733 128.843262)",
    fill: "#fff",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.300d1204ea028df523fa1f9e812c3fae.svg";
export { ForwardRef as ReactComponent };